<!-- web -->
<div
  class="tournament-popup-container animate__zoomIn_light animate__animated animate__fast"
  *ngIf="show && !isH5()"
  cdkDrag
  cdkDragRootElement="app-statistics-panel"
  cdkDragBoundary="body"
  #dragCom="cdkDrag"
  [cdkDragFreeDragPosition]="defaultDragPosition"
  [intersectionObserver]="true"
  (intersectChange)="intersectChange$.next($event)"
  [appLoading]="loading"
>
  <ng-container *ngTemplateOutlet="popupCont"></ng-container>
</div>

<!-- h5 -->
<div
  class="tournament-popup-container animate__zoomIn_light animate__animated animate__fast"
  *ngIf="show && isH5()"
  (intersectChange)="intersectChange$.next(true)"
  [appLoading]="loading"
>
  <ng-container *ngTemplateOutlet="popupCont"></ng-container>
</div>

<ng-template #popupCont>
  <div class="popup-header">
    <div class="header-details">
      <p class="title">{{ 'tournament' | translate }}</p>
    </div>
    <i class="icon-error mutual-opacity onact96-not close-anim" (click)="closePopup()"></i>
  </div>
  <ng-container *ngIf="renderTournament() && renderTournament().length > 1">
    <div class="arrow-group">
      <!-- 上一页 -->
      <div class="control-left onact96" (click)="previous()" [class.disabled]="renderCurrentIndex() === 0">
        <i class="icon-left-arrow"></i>
      </div>
      <!-- 下一页 -->
      <div
        class="control-right onact96"
        (click)="next()"
        [class.disabled]="renderCurrentIndex() === renderTournament().length - 1"
      >
        <i class="icon-right-arrow"></i>
      </div>
    </div>
  </ng-container>

  <ng-container *ngIf="renderTournament()?.length; else defaultEmpty">
    <div
      class="popup-banner"
      [class]="renderCurrentIndex() % 2 === 0 ? 'even' : 'odd'"
      *ngIf="!loading"
      (click)="onGoTournament()"
    >
      <app-lazy-image
        class="banner-img"
        [lazy]="this.tournament()[renderCurrentIndex()].activityThumbnails || ''"
        [thumbWidth]="80"
        [ratio]="4"
      ></app-lazy-image>
      <div class="banner-info">
        <p class="banner-title">{{ renderTournament()[renderCurrentIndex()].activityName || '' }}</p>
        <p class="banner-sub-title">{{ renderTournament()[renderCurrentIndex()].activitySubName || '' }}</p>
      </div>
      <i class="icon-right-arrow mutual-opacity onact96-not"></i>
    </div>
    <div class="popup-timer" *ngIf="renderTournament()[renderCurrentIndex()].remainingTime">
      <p class="timer-title">{{ 'end_in' | translate }}</p>
      <app-tournament-timer [calcTimer]="renderTournament()[renderCurrentIndex()].remainingTime"></app-tournament-timer>
    </div>
    <div class="popup-rank-list">
      <app-scrollbar>
        <ng-container *ngIf="renderTournament()[renderCurrentIndex()]?.pageTable?.records?.length; else emtpyRank">
          <table>
            <thead>
              <th *ngFor="let title of ['rank_a', 'gamer', 'bonus_t', 'score']">
                {{ title | translate }}
              </th>
            </thead>
            <tbody>
              <tr
                *ngFor="let rank of renderTournament()[renderCurrentIndex()]?.pageTable?.records; let index = index"
                [class.high-light]="
                  rank.rankNumber === renderTournament()[renderCurrentIndex()].currentUserRank?.rankNumber
                "
              >
                <td>
                  <img
                    *ngIf="rank.rankNumber < 4; else pureNumber"
                    class="badge"
                    [src]="'assets/images/daily-races/' + rank.rankNumber + '.svg'"
                    lazy="loading"
                    alt=""
                  />
                  <ng-template #pureNumber> {{ rank.rankNumber || '' }} </ng-template>
                </td>
                <td>{{ rank.userName || ('invisible' | translate) }}</td>
                <td class="amount-color">
                  <span>{{ rank.amount || 0 | transToDefaultCurrency: rank?.currency || 'USDT' }}</span>
                  <img class="currency-img" [src]="renderDefaultCurrency() || 'USDT' | currencyIcon" />
                </td>
                <td>{{ rank.rankScore || 0 | currencyValue: 'CNY' : undefined : undefined : 2 }}</td>
              </tr>
              <ng-container *ngIf="renderTournament()[renderCurrentIndex()].currentUserRank?.rankNumber">
                <tr
                  class="high-light"
                  *ngIf="renderTournament()[renderCurrentIndex()].currentUserRank!.rankNumber > 10"
                >
                  <td>{{ renderTournament()[renderCurrentIndex()].currentUserRank?.rankNumber || 0 }}</td>
                  <td>
                    {{
                      renderTournament()[renderCurrentIndex()].currentUserRank?.userName || ('invisible' | translate)
                    }}
                  </td>
                  <td class="amount-color">
                    <span>
                      {{
                        renderTournament()[renderCurrentIndex()].currentUserRank?.amount || 0
                          | transToDefaultCurrency
                            : renderTournament()[renderCurrentIndex()].currentUserRank?.currency || 'USDT'
                      }}</span
                    >
                    <img class="currency-img" [src]="renderDefaultCurrency() || 'USDT' | currencyIcon" />
                  </td>
                  <td>
                    {{
                      renderTournament()[renderCurrentIndex()].currentUserRank?.rankScore || 0
                        | currencyValue: 'CNY' : undefined : undefined : 2
                    }}
                  </td>
                </tr>
              </ng-container>
            </tbody>
          </table>
        </ng-container>
        <ng-template #emtpyRank>
          <app-empty *ngIf="!loading" [text]="'no_tournament_rank' | translate"></app-empty>
        </ng-template>
      </app-scrollbar>
    </div>
  </ng-container>
  <ng-template #defaultEmpty>
    <div class="empty-container">
      <app-empty *ngIf="!loading" [text]="'no_tournaments' | translate"></app-empty>
    </div>
  </ng-template>
</ng-template>
